import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import DeleteSharpIcon from "@mui/icons-material/DeleteSharp";
import Cookies from "js-cookie";
import { setUser } from "../store/auth";
import CategoryForm from "../components/CategoryForm";

export default function Category() {
  const token = Cookies.get("token");
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const [editCategory, setEditCategory] = useState({});

  function setEdit(category) {
    setEditCategory(category);
  }

  async function remove(label) {
    const category = user.categories.find((cat) => cat.label === label);
    if (!category) return;

    const res = await fetch(`${process.env.REACT_APP_API_URL}/category/${category._id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (res.ok) {
      const updatedCategories = user.categories.filter((cat) => cat.label !== label);
      const _user = { ...user, categories: updatedCategories };
      dispatch(setUser({ user: _user }));
      setEditCategory({}); // Clear edit mode after deletion
    }
  }

  function updateCategory(updatedCategory) {
    const updatedCategories = user.categories.map((cat) =>
      cat._id === updatedCategory._id ? updatedCategory : cat
    );
    const _user = {
      ...user,
      categories: updatedCategories,
    };
    dispatch(setUser({ user: _user }));
    setEditCategory({}); // Clear edit mode after update
  }

  return (
    <Container>
      <CategoryForm
        editCategory={editCategory}
        setEditCategory={setEditCategory}
        updateCategory={updateCategory}
      />
      <Typography variant="h6" sx={{ marginTop: 4 }}>
        List of Categories
      </Typography>
      <TableContainer component={Paper} sx={{ marginTop: 2 }}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">Label</TableCell>
              <TableCell align="center">Icon</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {user.categories.map((row) => (
              <TableRow key={row._id}>
                <TableCell align="center">{row.label}</TableCell>
                <TableCell align="center">{row.icon}</TableCell>
                <TableCell align="center">
                  <IconButton
                    color="warning"
                    onClick={() => setEdit(row)}
                    disabled={!!editCategory.label}
                  >
                    <EditSharpIcon />
                  </IconButton>
                  <IconButton
                    color="error"
                    onClick={() => remove(row.label)}
                    disabled={!!editCategory.label}
                  >
                    <DeleteSharpIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
}
